// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2dLcj","info":"UpdateTermsInfo_info__16Wsm"};